// src/i18n/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./local/en.json";
import or from "./local/or.json";
import hi from "./local/hi.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      or: { translation: or },
      hi: { translation: hi },
    },

    lng: "hi",              
    fallbackLng: "hi",     

    supportedLngs: ["en", "or", "hi"],
    nonExplicitSupportedLngs: true,

    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;